import { render, staticRenderFns } from "./ProjectView.vue?vue&type=template&id=975c1b00&scoped=true&"
import script from "./ProjectView.vue?vue&type=script&lang=ts&"
export * from "./ProjectView.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectView.vue?vue&type=style&index=0&id=975c1b00&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975c1b00",
  null
  
)

export default component.exports